import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _isEmpty from "lodash/isEmpty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import fieldValidationService from './fieldValidationService';
export var validateField = function validateField(field) {
  return function (value, _, meta) {
    var fieldError = fieldValidationService(value, field);
    if (_isEmpty(meta)) return fieldError;

    // If meta exists (field-level validation), only show error based on the error configuration:
    // - error.hideBeforeSubmit - Used to only show error after a submission failed
    // - error.hideIfTouched - Used to only show error when field is pristine, and hide error afterwards
    var shouldShowError = fieldError && (!fieldError.hideBeforeSubmit || fieldError.hideBeforeSubmit && meta.submitFailed) && (!fieldError.hideIfTouched || fieldError.hideIfTouched && !meta.touched);
    return shouldShowError ? fieldError : undefined;
  };
};

// Used to validate multiple fields during a form submission
export var validateFields = function validateFields(fields) {
  return function (values) {
    return fields.reduce(function (acc, field) {
      var value = values[field.name];
      var error = validateField(field)(value);
      if (!error) return acc;
      return _objectSpread(_objectSpread({}, acc), {}, _defineProperty({}, field.name, error));
    }, {});
  };
};